module.exports = __webpack_public_path__ + "src/assets/img/page2/0d6b5cdbb5de7084a64bfea594b9fd8d.png";